module.exports = __webpack_public_path__ + "img/stbarts.8f89e624.svg";